module.exports = __webpack_public_path__ + "vue-assets/img/paper_plan.ed900c5c.png";